import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import styles from './SaveToAllOutletsModal.css'
import {hideSaveToAllOutletsModal} from 'actions/library/item'
import {connect} from 'react-redux'

class SaveToAllOutletsModal extends React.Component {
  render () {
    const {showSaveToAllOutletsModal} = this.props

    return (
      <Modal className={styles['container']} show={showSaveToAllOutletsModal} backdrop='static' onHide={this._onClickOK} dialogClassName={`modal-dialog ${styles.dialog}`}>
        <ModalHeader className={styles['title']} title={'Information'} />
        <Modal.Body>
          <div>
            Create item is in process. This process may take a few minutes.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span className='pull-right'>
            <button className='btn btn-default' onClick={this._onClickOK}>
              OK
            </button>
          </span>
        </Modal.Footer>
      </Modal>)
  }

  _onClickOK = () => {
    this.props.dispatch(hideSaveToAllOutletsModal())
  }
}

function mapStateToProps (state) {
  const {showSaveToAllOutletsModal} = state.library.item
  return {
    showSaveToAllOutletsModal
  }
}

export default connect(mapStateToProps)(SaveToAllOutletsModal)



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/SaveToAllOutletsModal/SaveToAllOutletsModal.js